import { Action, SubjectRoles } from "@/api-schema-enums";
import { checkPermission } from "@/common/helpers/navigation";
import type { AppRoleRequirement, PermissionRequirement } from "@/config/navigation/types";
import type { AnyAbility } from "@casl/ability";

export const MASTERDATA_AUDIENCE = SubjectRoles.Int;
export const MASTERDATA_PERMISSION: AppRoleRequirement = { appRole: SubjectRoles.Int };
export const MASTERDATA_USER_PERMISSION: PermissionRequirement = { action: Action.Read, subject: "User" };

export function getUserDetailPath(userUuid: string): string {
  return `~/masterdata/user/${userUuid}`;
}

export function canViewUserDetail(ability: AnyAbility, userRoles: readonly SubjectRoles[] = []): boolean {
  const roles = [...userRoles];
  return (
    roles.includes(MASTERDATA_AUDIENCE) &&
    checkPermission(ability, MASTERDATA_PERMISSION, roles) &&
    checkPermission(ability, MASTERDATA_USER_PERMISSION, roles)
  );
}
